import _defineProperty from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Tabs/tabs';
import { TabButton } from './TabButton';
import { TabsContext } from './TabsContext';
import { css } from '@patternfly/react-styles';

var TabBase = function TabBase(_a) {
  var title = _a.title,
      eventKey = _a.eventKey,
      tabContentRef = _a.tabContentRef,
      childId = _a.id,
      tabContentId = _a.tabContentId,
      _a$className = _a.className,
      childClassName = _a$className === void 0 ? '' : _a$className,
      childOuiaId = _a.ouiaId,
      isDisabled = _a.isDisabled,
      isAriaDisabled = _a.isAriaDisabled,
      _a$inoperableEvents = _a.inoperableEvents,
      inoperableEvents = _a$inoperableEvents === void 0 ? ['onClick', 'onKeyPress'] : _a$inoperableEvents,
      href = _a.href,
      innerRef = _a.innerRef,
      props = __rest(_a, ["title", "eventKey", "tabContentRef", "id", "tabContentId", "className", "ouiaId", "isDisabled", "isAriaDisabled", "inoperableEvents", "href", "innerRef"]);

  var preventedEvents = inoperableEvents.reduce(function (handlers, eventToPrevent) {
    return Object.assign(Object.assign({}, handlers), _defineProperty({}, eventToPrevent, function (event) {
      event.preventDefault();
    }));
  }, {});

  var _React$useContext = React.useContext(TabsContext),
      mountOnEnter = _React$useContext.mountOnEnter,
      localActiveKey = _React$useContext.localActiveKey,
      unmountOnExit = _React$useContext.unmountOnExit,
      uniqueId = _React$useContext.uniqueId,
      handleTabClick = _React$useContext.handleTabClick;

  var ariaControls = tabContentId ? "".concat(tabContentId) : "pf-tab-section-".concat(eventKey, "-").concat(childId || uniqueId);

  if ((mountOnEnter || unmountOnExit) && eventKey !== localActiveKey) {
    ariaControls = undefined;
  }

  var isButtonElement = Boolean(!href);

  var getDefaultTabIdx = function getDefaultTabIdx() {
    if (isDisabled) {
      return isButtonElement ? null : -1;
    } else if (isAriaDisabled) {
      return null;
    }
  };

  return React.createElement("li", {
    className: css(styles.tabsItem, eventKey === localActiveKey && styles.modifiers.current, childClassName),
    ref: innerRef
  }, React.createElement(TabButton, Object.assign({
    className: css(styles.tabsLink, isDisabled && href && styles.modifiers.disabled, isAriaDisabled && styles.modifiers.ariaDisabled),
    disabled: isButtonElement ? isDisabled : null,
    "aria-disabled": isDisabled || isAriaDisabled,
    tabIndex: getDefaultTabIdx(),
    onClick: function onClick(event) {
      return handleTabClick(event, eventKey, tabContentRef);
    }
  }, isAriaDisabled ? preventedEvents : null, {
    id: "pf-tab-".concat(eventKey, "-").concat(childId || uniqueId),
    "aria-controls": ariaControls,
    tabContentRef: tabContentRef,
    ouiaId: childOuiaId,
    href: href
  }, props), title));
};

export var Tab = React.forwardRef(function (props, ref) {
  return React.createElement(TabBase, Object.assign({
    innerRef: ref
  }, props));
});
Tab.displayName = 'Tab';